import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Download, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Check if user has dismissed before
      const dismissed = localStorage.getItem('pwa-install-dismissed');
      if (!dismissed) {
        // Show install prompt after 3 seconds
        setTimeout(() => {
          setShowInstallPrompt(true);
        }, 3000);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user's response
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to install prompt: ${outcome}`);

    // Clear the deferred prompt
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  if (!showInstallPrompt || !deferredPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-up">
      <div className="bg-white rounded-lg shadow-2xl border-2 border-emerald-500 p-4">
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
        
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
              <Download className="h-6 w-6 text-emerald-600" />
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {t('pwa.installTitle', 'App installieren')}
            </h3>
            <p className="text-sm text-gray-600 mb-3">
              {t('pwa.installDescription', 'Fügen Sie Brillanz & Glanz zu Ihrem Home-Bildschirm hinzu für schnellen Zugriff und ein App-ähnliches Erlebnis.')}
            </p>
            
            <div className="flex space-x-2">
              <Button
                onClick={handleInstallClick}
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
              >
                {t('pwa.install', 'Installieren')}
              </Button>
              <Button
                onClick={handleDismiss}
                variant="outline"
                className="border-gray-300"
              >
                {t('pwa.later', 'Später')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
